export const CONTACT_INFO_FILTER = 'lybunt_contact_info_filter';
export const COMPLETE_LIST_FILTER = 'lybunt_complete_list_filter';
export const RECENT_ACTIVITY_FILTER = 'lybunt_recent_activity_filter';

export const lybuntInitialState = {
	filter: {
		[COMPLETE_LIST_FILTER]: { value: {}, label: 'Complete List' },
		[CONTACT_INFO_FILTER]: [],
		[RECENT_ACTIVITY_FILTER]: [],
	},
};



// WEBPACK FOOTER //
// ./src/redux/lybunt/lybunt.initialState.js